function renderHTML(getSelectedTemplate) {
    document.getElementById("web-logo").src = getSelectedTemplate.config.logoDetails.logoImg;
    document.getElementById("web-logo").style.height = getSelectedTemplate.config.logoDetails.height + "px";
    
    let newVal = getSelectedTemplate.config.answerGridSection.selectedMode;

    if(newVal == "dark") {
        updateDarkModeOpacity(getSelectedTemplate.config.answerGridSection.darkModeOpacity/100);
    } else if(newVal == "light") {
        updateLighModeOpacity(getSelectedTemplate.config.answerGridSection.lightModeOpacity/100);
    }

    let className = "."+newVal + "-mode.headline-bg";
    document.querySelectorAll(className).forEach(element => {
        element.style.backgroundColor= hexToRgbA(getSelectedTemplate.config.headerSection.backgroundColor, getSelectedTemplate.config.headerSection.backgroundOpacity/100);
    });
    //update font-color
    document.querySelectorAll('.k-navbar,.headline__middle.new-poll,'+className).forEach(element => {
        element.style.color= hexToRgbA(getSelectedTemplate.config.headerSection.fontColor);
    });

    // update border-color
    document.querySelectorAll('.headline__middle.new-poll').forEach(element => {
        element.style.borderColor = hexToRgbA(getSelectedTemplate.config.headerSection.fontColor);
    });
}
  
function hexToRgbA(hex, opacity = 1){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+ opacity +')';
    }
    throw new Error('Bad Hex');
}

function updateDarkModeOpacity(opacity) {
    setTimeout(() => {
        document.querySelectorAll('.view-content.dark-mode-bg,.legend-content.dark-mode-bg,.legend-content-mobile.dark-mode-bg, .view-content.dark-mode-bg-ff, .legend-content.dark-mode-bg-ff, .legend-content-mobile.dark-mode-bg-ff, .view-task-content.dark-mode-bg-ff, .view-task-content.dark-mode-bg').forEach(element => {
            element.style.backgroundColor= "rgba(0, 0, 0, "+ opacity +")"
        });
    }, 200);
}

function updateLighModeOpacity(opacity) {
    setTimeout(() => {
        document.querySelectorAll('.view-content.light-mode, .legend-content.light-mode, .legend-content-mobile.light-mode, .view-content.light-mode-bg, .legend-content.light-mode-bg, .view-content.light-mode-bg-ff, .legend-content.light-mode-bg-ff, .view-task-content.light-mode-bg-ff, .view-task-content.light-mode-bg').forEach(element => {
            element.style.backgroundColor= "rgba(255, 255, 255, "+ opacity +")"
        });
    }, 200);
}

function updateBackgroundWithOpacity(color, mode, opacity = 1) {
    setTimeout(() => {
        let className = "."+ mode + "-mode.headline-bg";
        let hexa = hexToRgbA(color, opacity);
        document.querySelectorAll(className).forEach(element => {
            element.style.backgroundColor= hexa;
        });
    }, 200);
}

function updateFontColor(color, mode) {
    let className = "."+ mode + "-mode.headline-bg";
    let hexa = hexToRgbA(color);
    document.querySelectorAll('.k-navbar,.headline__middle.new-poll,'+className).forEach(element => {
        element.style.color= hexa;
    });
}

exports.renderHTML = renderHTML;
exports.hexToRgbA = hexToRgbA;
exports.updateDarkModeOpacity = updateDarkModeOpacity;
exports.updateLighModeOpacity = updateLighModeOpacity;
exports.updateBackgroundWithOpacity = updateBackgroundWithOpacity;
exports.updateFontColor = updateFontColor;